import ArchivePostsDesktopList from './archive-posts-desktop-list';
import ArchivePostsMobileList from './archive-posts-mobile-list';
import forDevice from '../../../common/hoc/for-device';

const ArchivePostsList = forDevice(ArchivePostsMobileList, ArchivePostsDesktopList);
export default ArchivePostsList;
